import { DEPARTMENT_TYPES } from "./types"

export const getAllDepartmentsRequest = (data) => ({
  type: DEPARTMENT_TYPES.GET_ALL_DEPARTMENTS_REQUEST,
  payload: data
})

export const getAllDepartmentsSuccess = (data) => ({
  type: DEPARTMENT_TYPES.GET_ALL_DEPARTMENTS_SUCCESS,
  payload: data
})

export const getAllDepartmentsFailure = (data) => ({
  type: DEPARTMENT_TYPES.GET_ALL_DEPARTMENTS_FAIL,
  payload: data
})

export const createDepartmentRequest = (data) => ({
  type: DEPARTMENT_TYPES.CREATE_DEPARTMENT_REQUEST,
  payload: data
})

export const createDepartmentSuccess = (data) => ({
  type: DEPARTMENT_TYPES.CREATE_DEPARTMENT_SUCCESS,
  payload: data
})

export const createDepartmentFailure = (data) => ({
  type: DEPARTMENT_TYPES.CREATE_DEPARTMENT_FAIL,
  payload: data
})

export const updateDepartmentRequest = (data) => ({
  type: DEPARTMENT_TYPES.UPDATE_DEPARTMENT_REQUEST,
  payload: data
})

export const updateDepartmentSuccess = (data) => ({
  type: DEPARTMENT_TYPES.UPDATE_DEPARTMENT_SUCCESS,
  payload: data
})

export const updateDepartmentFailure = (data) => ({
  type: DEPARTMENT_TYPES.UPDATE_DEPARTMENT_FAIL,
  payload: data
})

export const deleteDepartmentRequest = (data) => ({
  type: DEPARTMENT_TYPES.DELETE_DEPARTMENT_REQUEST,
  payload: data
})

export const deleteDepartmentSuccess = (data) => ({
  type: DEPARTMENT_TYPES.DELETE_DEPARTMENT_SUCCESS,
  payload: data
})

export const deleteDepartmentFailure = (data) => ({
  type: DEPARTMENT_TYPES.DELETE_DEPARTMENT_FAIL,
  payload: data
})
